
  <div class="ngb-dp-arrow">
    <button type="button" class="btn btn-link ngb-dp-arrow-btn"
            (click)="!!navigate.emit(navigation.PREV)" [disabled]="prevDisabled">
      <span class="ngb-dp-navigation-chevron"></span>
    </button>
  </div>
    <ngb-datepicker-navigation-select *ngIf="showSelect" class="d-block ngb-dp-navigation-select"
      [date]="date"
      [disabled] = "disabled"
      [months]="selectBoxes.months"
      [years]="selectBoxes.years"
      (select)="select.emit($event)">
    </ngb-datepicker-navigation-select>

    <ng-template *ngIf="!showSelect" ngFor let-month [ngForOf]="months" let-i="index">
      <div class="ngb-dp-arrow" *ngIf="i > 0"></div>
      <div class="ngb-dp-month-name d-block">
        {{ i18n.getMonthFullName(month.number) }} {{ month.year }}
      </div>
      <div class="ngb-dp-arrow" *ngIf="i !== months.length - 1"></div>
    </ng-template>
    <div class="ngb-dp-arrow right">
    <button type="button" class="btn btn-link ngb-dp-arrow-btn"
            (click)="!!navigate.emit(navigation.NEXT)" [disabled]="nextDisabled">
      <span class="ngb-dp-navigation-chevron"></span>
    </button>
    </div>
    